import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "./msalConfig";
import { isAuthConfigured } from "./msalConfig";

function ProtectedRoute({ children }) {
  const isAuthenticated = useIsAuthenticated();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (!isAuthConfigured()) return;
    if (inProgress === InteractionStatus.None && !isAuthenticated) {
      instance.loginRedirect(loginRequest).catch(() => {});
    }
  }, [inProgress, isAuthenticated, instance]);

  if (!isAuthConfigured()) {
    return children;
  }

  if (
    inProgress === InteractionStatus.Startup ||
    inProgress === InteractionStatus.HandleRedirect
  ) {
    return (
      <div className="App" style={{ padding: "2rem", textAlign: "center" }}>
        <p>Completing sign in…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="App" style={{ padding: "2rem", textAlign: "center" }}>
        <p>Redirecting to sign in…</p>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
